import { dateFormat, formatDateTime } from "../../../../../utils/dateFormat";

export const lockDetails = (object) => {
  const {
    firstName: recordRequestedFirstName,
    middleName: recordRequestedMiddleName,
    lastName: recordRequestedLastName,
    alias: recordRequestedAlias,
    lockedTo,
    lockedDate,
    specificDateLocked,
    remainLockedDate,
    company,
    lockedDateString,
    createdAt,
  } = object?.prev_record_requested?.prev
    ? object?.prev_record_requested?.prev
    : object?.no_record
      ? object.no_record_requested
      : object.record_requested;
  // object?.no_record ? object.no_record_requested : object.record_requested;

  console.log("specificLockedDate", specificDateLocked);
  console.log("remain", remainLockedDate);

  // Check if lockedTo is an object or just an ID
  const isLockedToObject = typeof lockedTo === "object" && lockedTo !== null;

  // Helper function to safely get nested values
  const getLockedToValue = (path, defaultValue = "N/A") => {
    console.log("pat", path);
    if (!isLockedToObject) return defaultValue;
    return (
      path.split(".").reduce((obj, key) => obj?.[key], lockedTo) || defaultValue
    );
  };
  return [
    {
      label: "Search Name",
      value: `${recordRequestedFirstName || ""} ${
        recordRequestedMiddleName || ""
      } ${recordRequestedLastName || ""}  ${recordRequestedAlias || ""} ${company || ""}`,
    },
    // {
    //   label: "Search Date",
    //   value: "",
    // },
    {
      label: "Date Locked",
      // value: formatDateTime(lockedDate ?? object?.createdAt),
      // value: formatDateTime(
      //   object?.approveDetails ? remainLockedDate : lockedDate,
      // ),
      value: formatDateTime(
        object?.approveDetails
          ? (remainLockedDate ?? lockedDateString)
          : (lockedDate ?? lockedDateString ?? createdAt),
      ),
      // value: formatDateTime(
      //   object?.approveDetails
      //     ? (remainLockedDate ?? lockedDateString)
      //     : lockedDate,
      // ),
    },
    // {
    //   label: "Locked By",
    //   value: `${lockedTo?.firstName} ${lockedTo?.middleName || ""} ${
    //     lockedTo?.lastName
    //   }  (${lockedTo?.username})`,
    // },
    // {
    //   label: "Affiliate",
    //   value: lockedTo?.affiliate?.code || lockedTo?.affiliate?.id,
    // },
    // {
    //   label: "Branch",
    //   value: lockedTo?.branch.code || lockedTo?.branch?.id,
    // },
    {
      label: "Locked By",
      value: isLockedToObject
        ? `${lockedTo.firstName || ""} ${lockedTo.middleName || ""} ${
            lockedTo.lastName || ""
          } ${lockedTo.username ? `(${lockedTo.username})` : lockedTo.id}`
            .replace(/\s+/g, " ")
            .trim()
        : lockedTo || "N/A",
    },
    {
      label: "Affiliate",
      value: isLockedToObject
        ? lockedTo.affiliate?.code ||
          lockedTo.affiliate?.id ||
          lockedTo.id ||
          "N/A"
        : "N/A",
    },
    {
      label: "Branch",
      value: isLockedToObject
        ? lockedTo.branch?.code || lockedTo.branch?.id || "N/A"
        : "N/A",
    },
  ];
};
